import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import {
  FilterDate,
  FilterCheckbox,
  FilterCheckboxSearch,
  FilterWrapper,
  FilterInput,
} from "../../../../../components/Filter";
import FastFieldWrapper from "../../../../../components/form/FastFieldWrapper";
import { preOrderFieldNames, preOrderStatusOptionList } from "./constants";
import { useRect } from "../../../../../utils";

const SingleFilterContainer = styled.div`
  margin-bottom: 16px;
  transition: opacity ease-out 0.3s;
  opacity: 1;
  width: auto;
  display: flex;
  align-items: center;
  height: 48px;
  margin: 0;

  ${({ allFiltersRefSetted }) =>
    !allFiltersRefSetted &&
    `
    opacity: 0;
  `}
`;

const FiltersContainer = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  transition: height ease-out 0.3s;
  flex-direction: column;
`;

const FiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const Filters = ({
  onSearch,
  appliedFilters,
  authorList,
  onRequestAuthorList,
}) => {
  const [allFiltersRefSetted, setAllFiltersRefSetted] = useState(false);
  const filtersContainerRef = useRef();
  const filtersBounding = useRect(filtersContainerRef);

  const filtersRef = {
    [preOrderFieldNames.CREATE_DATE]: useRef(),
    [preOrderFieldNames.AUTHOR]: useRef(),
    [preOrderFieldNames.STATUS]: useRef(),
  };

  useEffect(() => {
    const allSetted = Object.entries(filtersRef).every(
      ([, ref]) => !!ref.current
    );
    if (allSetted) {
      setAllFiltersRefSetted(true);
    }
  }, [
    filtersRef[preOrderFieldNames.CREATE_DATE],
    filtersRef[preOrderFieldNames.AUTHOR],
    filtersRef[preOrderFieldNames.STATUS],
    filtersBounding.rect.right,
  ]);

  return (
    <FilterWrapper
      renderTop={() => (
        <FilterInput
          name={preOrderFieldNames.SEARCH}
          placeholder="Buscar ref. do pré-pedido"
          typeInput="text"
          handleOutput={onSearch}
          submitOnChange
          minChar={1}
        />
      )}
      renderBottomLeft={() => (
        <FiltersContainer>
          <FiltersWrapper ref={filtersContainerRef}>
            <SingleFilterContainer
              ref={filtersRef[preOrderFieldNames.CREATE_DATE]}
              allFiltersRefSetted={allFiltersRefSetted}
            >
              <FastFieldWrapper
                name={preOrderFieldNames.CREATE_DATE}
                label="Data de criação"
                component={FilterDate}
                submitOnChange
                appliedFilters={appliedFilters}
                fieldNames={preOrderFieldNames}
              />
            </SingleFilterContainer>
            <SingleFilterContainer
              ref={filtersRef[preOrderFieldNames.AUTHOR]}
              allFiltersRefSetted={allFiltersRefSetted}
            >
              <FastFieldWrapper
                name={preOrderFieldNames.AUTHOR}
                label="Criado por"
                placeholder="Criado por"
                component={FilterCheckboxSearch}
                submitOnChange
                optionList={authorList.list}
                optionMap={({ id, name }) => ({
                  label: name,
                  value: id,
                })}
                onSearch={onRequestAuthorList}
                loading={authorList.loading}
                appliedFilters={appliedFilters}
                fieldNames={preOrderFieldNames}
              />
            </SingleFilterContainer>
            <SingleFilterContainer
              ref={filtersRef[preOrderFieldNames.STATUS]}
              allFiltersRefSetted={allFiltersRefSetted}
            >
              <FastFieldWrapper
                name={preOrderFieldNames.STATUS}
                label="Status"
                component={FilterCheckbox}
                submitOnChange
                optionList={preOrderStatusOptionList}
                appliedFilters={appliedFilters}
                fieldNames={preOrderFieldNames}
              />
            </SingleFilterContainer>
          </FiltersWrapper>
        </FiltersContainer>
      )}
    />
  );
};

export default Filters;
